import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";

import './Navbar.css';


function Navbar({showAdminTab}) {
  const location = useLocation();
  const [username, setUsername] = useState(null);

  const id_role = window.localStorage.getItem('id_role');
  const can_read_machinetype = JSON.parse(window.localStorage.getItem('can_read_machinetype'));
  const can_read_yarn = JSON.parse(window.localStorage.getItem('can_read_yarn'));
  const can_read_contactingrecipe = JSON.parse(window.localStorage.getItem('can_read_contactingrecipe'));
  
  // Abfrage, wenn die Rolle nicht admin ist, dann wird der Reiter Benutzerverwaltung in der Navbar nicht angezeigt
  id_role > 2 ? showAdminTab = false : showAdminTab = true

  
  useEffect(() => {
    const username = window.localStorage.getItem('username');

    setUsername(username);
  }, [location.state]);


  const currentPage = location.pathname;

  const isActive = (path) => {
    return currentPage === path ? 'active' : '';

  };

  const handleLogout = () => {
    
    window.localStorage.removeItem('id_institution');
    window.localStorage.removeItem('id_person');
    window.localStorage.removeItem('id_role');
    window.localStorage.removeItem('username');

    window.localStorage.removeItem('can_create_machinetype');
    window.localStorage.removeItem('can_read_machinetype');
    window.localStorage.removeItem('can_update_machinetype');
    window.localStorage.removeItem('can_delete_machinetype');

    window.localStorage.removeItem('can_create_machine_configuration');
    window.localStorage.removeItem('can_read_machine_configuration');
    window.localStorage.removeItem('can_update_machine_configuration');
    window.localStorage.removeItem('can_delete_machine_configuration');

    window.localStorage.removeItem('can_create_yarn');
    window.localStorage.removeItem('can_read_yarn');
    window.localStorage.removeItem('can_update_yarn');
    window.localStorage.removeItem('can_delete_yarn');
    
    window.localStorage.removeItem('can_create_contactingrecipe');
    window.localStorage.removeItem('can_read_contactingrecipe');
    window.localStorage.removeItem('can_update_contactingrecipe');
    window.localStorage.removeItem('can_delete_contactingrecipe'); 
    
    window.localStorage.removeItem('id_machinetype'); 
    
    window.localStorage.removeItem("access_token");
    // window.localStorage.removeItem("expires_at");
  };


  // Funktion zum Setzen der id_machinetype auf 0, wenn die vorher besuchte Seite nicht knittingmachineconfiguration war
  // Zeile in der Tabelle nicht mehr markiert
  const handleMachinetypeClick = () => {
    const previousPage = window.localStorage.getItem('previousPage');
    if (previousPage !== '/knittingmachineconfiguration') {
      window.localStorage.setItem('id_machinetype', 0); // Keine Zeile markiert
    }
  };

 
  
  return (
    <div className='navbar'>
      <ul className='navbar-menu-left'>
        {can_read_machinetype && (
          <Link to="/knittingmachinetype">
            <button
              className={isActive('/knittingmachinetype')}
              onClick={handleMachinetypeClick}
            >
              Strickmaschinentyp
            </button>
          </Link>
        )}
        {can_read_yarn && (
          <Link to="/yarn"><button className={isActive('/yarn')}>Funktionsgarn</button></Link>
        )}
        {can_read_yarn && (
          <Link to="/basicyarn"><button className={isActive('/basicyarn')}>Trägergarn</button></Link>
        )}
        {can_read_contactingrecipe && (
          <Link to="/contactingrecipe"><button className={isActive('/contactingrecipe')}>Kontaktierungsrezept</button></Link>
        )}          
      </ul>
      <ul className='navbar-menu-right'>    
        {showAdminTab && (
          <Link to="/administration"><button className={isActive('/administration')}>Benutzerverwaltung</button></Link>
        )}
        <Link to="/"><button className={isActive('/')} onClick={handleLogout}>Logout ({username})</button></Link>
      </ul>
    </div>
  )
}

export default Navbar
